const CLARITY_ID = 'yc609auqqo'

/**
 * Injects the official Microsoft Clarity tag into <head>. The project has no
 * editable index.html, so the snippet is added as an inline script at runtime
 * (before React renders), which Clarity treats the same as a hardcoded tag.
 */
export function initClarity() {
  if (typeof window === 'undefined') return
  if (document.getElementById('ms-clarity-tag')) return

  const script = document.createElement('script')
  script.id = 'ms-clarity-tag'
  script.type = 'text/javascript'
  script.text = `(function(c,l,a,r,i,t,y){
    c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
    t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
    y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
  })(window, document, "clarity", "script", "${CLARITY_ID}");`

  document.head.appendChild(script)
}
